<template>
  <div>
    <div class="tagMonitoring-title">
      <div>标签监控</div>
      <div>
        <Button
          v-hasPermission="['labelManagement:tagMonitoring:add']"
          type="primary"
          @click="addOrUpdateHandle"
          >添加标签监控</Button
        >
        <add-or-update-tag-monitoring
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-tag-monitoring>
      </div>
    </div>
    <template>
      <div class="tagMonitoring-top">
        <tag-monitoring-search ref="search"></tag-monitoring-search>
      </div>
      <table-tag-monitoring></table-tag-monitoring>
    </template>
  </div>
</template>

<script>
import TableTagMonitoring from "./TableTagMonitoring";
import TagMonitoringSearch from "./TagMonitoringSearch";
import AddOrUpdateTagMonitoring from "./AddOrUpdateTagMonitoring";

export default {
  name: "TagMonitoring",
  components: {
    TagMonitoringSearch,
    TableTagMonitoring,
    AddOrUpdateTagMonitoring
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.tagMonitoring-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.tagMonitoring-title > div:nth-child(1) {
  float: left;
}

.tagMonitoring-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.tagMonitoring-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_monitoring/TagMonitoring.vue